import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

// Zet een axios-fout om in één duidelijke Nederlandse zin (geen stacktrace voor de gebruiker).
export function errMessage(e) {
  if (!e?.response) {
    const backend = process.env.REACT_APP_BACKEND_URL || "de server";
    let here = "";
    try { here = window.location.origin; } catch { /* ignore */ }
    const hier = here && here !== backend ? ` Je bekijkt de app nu op ${here}; het juiste adres is ${backend}.` : "";
    return `De app kan de server niet bereiken. Vaak komt dit door een verouderde link of bookmark — open de app via het juiste adres en probeer opnieuw.${hier}`;
  }
  const detail = e.response.data?.detail;
  return `Fout ${e.response.status}${detail ? `: ${detail}` : " — de gegevens konden niet geladen worden."}`;
}

export function LoadError({ error, onRetry, testid = "load-error", className = "" }) {
  if (!error) return null;
  return (
    <div
      data-testid={testid}
      role="alert"
      className={`rounded-md border border-rose-200 bg-rose-50 p-4 flex items-start justify-between gap-3 ${className}`}
    >
      <div className="flex items-start gap-2.5">
        <AlertTriangle className="h-5 w-5 text-rose-600 shrink-0 mt-0.5" strokeWidth={2.2} />
        <div>
          <p className="text-sm font-semibold text-rose-800">Kon gegevens niet laden</p>
          <p className="text-sm text-rose-700">{error}</p>
        </div>
      </div>
      {onRetry && (
        <button
          data-testid={`${testid}-retry`}
          onClick={onRetry}
          className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-rose-600 text-white text-xs font-semibold hover:bg-rose-700 transition-colors"
        >
          <RefreshCw className="h-3.5 w-3.5" /> Opnieuw proberen
        </button>
      )}
    </div>
  );
}
